import React, { useState } from 'react'
import {motion } from "framer-motion";
import { toast } from 'react-toastify';
import "../index.css";
import PhoneInput from "react-phone-input-2";
import logo from "../assets/form/Logo.png";
import topShadow from "../assets/clientform/1-top.png";
import middleShadow from "../assets/clientform/2-middle.png";
import bottomShadow from "../assets/clientform/3-bottom.png";
import rightShadow from "../assets/clientform/4-right.png";
import { submitClientRequest } from "../services/api";
import Loader from '../components/Loader';
// For tracking if user has scrolled

const ExpertForm = () => {
   const initial = { name: '', email: '', phone: '', message: '' };
   const [data, setData] = React.useState(initial);
   const [formMsg, setFormMsg] = useState(null);
   const [loading, setLoading] = useState(false);

   const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const { name, email, phone, message } = data;

    try {
      setLoading(true);
      const response = await submitClientRequest(data);

      if(response.success){
        console.log('res', response);
        toast.success(response.msg);
        setLoading(false);

        setTimeout(() => {
          setData(initial);
        }, 2000);
      }
    }
    catch(err) {
      console.log("Error", err);
      if(err.response && err.status == 422) {
        toast.error(err.response.data.errors[0].message);
      } else {
        toast.error(err.message);
      }
      setLoading(false);
    }
   };
  return (
    <div className="bg-dark-indigo pb-[480px] sm:pb-[350px] px-4">
      <div className="img-section">
         <div className="left h-full">
            <motion.img 
              initial={{ opacity: 0, translateX: -100 }}
              animate={{ opacity: 1, translateX: 0 }}
              transition={{ duration: 0.5 }}
              src={topShadow} className='w-[120px] md:w-[330px] absolute top-[80px] sm:top-0 left-0' alt="top-image" />
            <motion.img 
              initial={{ opacity: 0, translateX: -100 }}
              animate={{ opacity: 1, translateX: 0 }}
              transition={{ duration: 0.5 }}
              src={middleShadow} 
              className='w-[80px] md:w-[100px] absolute top-[25%] transform translate-y-[-50%] left-0' alt="top-image" />
            <motion.img 
              initial={{ opacity: 0, translateY: -100 }}
              animate={{ opacity: 1, translateY: 0 }}
              transition={{ duration: 0.5 }}
              src={bottomShadow} className='w-[180px] sm:w-[230px] absolute bottom-0 sm:bottom-[-70px] left-0' alt="top-image" />
         </div>
         <div className="right h-full">
           <motion.img
            initial={{ opacity: 0, translateX: 100 }}
            animate={{ opacity: 1, translateX: 0 }}
            transition={{ duration: 0.5 }} 
            src={rightShadow} className='w-[180px] h-[91%] md:w-auto sm:h-full overflow-hidden absolute right-0' alt="top-image" />
         </div>
      </div>
      <div className="detail w-full pt-[30px] md:max-w-[807px] mx-auto text-center">
         <h1 className='capitalize text-[20px] sm:text-[25px] leading-[24px] sm:leading-[34px] font-medium text-white pt-[10px]'>Unlock extensive access to specialized <br /> 
         market insights.</h1>
         
          <motion.div 
            initial={{ opacity: 0, scale: 0.5 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8 }}
            className='flex justify-center items-center'
          >
            
              <form
                className="flex flex-col self-center w-full sm:max-w-[448px] mt-[30px] pb-8 max-w-full bg-white rounded-xl shadow-xl  form-right-section"
                onSubmit={(e) => handleSubmit(e)}
              >

              

              <div className="flex gap-2.5 px-4 py-2 text-xl font-semibold text-white whitespace-nowrap bg-light-indigo border-dark-indigo border-b-[3px] rounded-t-xl shadow-sm max-md:flex-wrap">
                <img alt="Expertefy Logo" src={logo} className="shrink-0 aspect-[1.03] w-[33px]" />
                <span className="flex-auto my-auto">EXPERTEFY</span>
              </div>

              <div className="flex flex-col px-5 max-md:max-w-full">
                <h2 className="text-xl font-bold text-color leading-[48.09px]">Got a Project in Mind?</h2>
                <label htmlFor="name" className="sr-only">Your Name</label>
                <input
                  type="text"
                  id="name"
                  className="box-border flex relative flex-col shrink-0 p-2.5  border-solid"
                  placeholder="Your Name"
                  aria-label="Your Name"
                  value={data.name}
                  onChange={(e) => setData(prev => ({ ...prev, "name": e.target.value }))}
                  required
                />

                <label htmlFor="email" className="sr-only">Your Email</label>
                <input
                  type="email"
                  id="email"
                  className="box-border flex relative flex-col shrink-0 p-2.5 mt-5  border-solid"
                  placeholder="Your Email"
                  aria-label="Your Email"
                  value={data.email}
                  onChange={(e) => setData(prev => ({ ...prev, "email": e.target.value }))}
                  required
                />

                <PhoneInput
                  className="box-border flex relative flex-col shrink-0 p-1.5 mt-5  border-b-2 border-solid"
                  inputStyle={{ borderStyle: "none", width: "inherit" }}
                  dropdownStyle={{
                    borderStyle: "solid",
                    border: 1,
                    borderColor: "#6369C4",
                    backgroundColor: "#fff",
                  }}
                  buttonStyle={{ borderStyle: "none", border: 0, backgroundColor: "#fff" }}
                  required
                  country={"us"}
                  value={data.phone}
                  onChange={(ph) => setData(prev => ({ ...prev, "phone": ph }))}
                />

                <label htmlFor="projectScope" className="sr-only">Let us know the project scope</label>
                <textarea
                  id="projectScope"
                  className="box-border flex relative flex-col shrink-0 px-2.5 pt-2.5 pb-4 my-5  border-solid"
                  placeholder="Let us know the project scope"
                  aria-label="Project Scope"
                  value={data.message}
                  onChange={(e) => setData(prev => ({ ...prev, "message": e.target.value }))}
                  required
                ></textarea>
                <button className="justify-center dark-button items-center self-center px-16 py-5 mt-7 max-w-full text-2xl text-center text-white rounded-lg  shadow-xl w-[323px] max-md:px-5">
                  { loading ? <Loader />: "Submit Request"}
                </button>
              </div>
            </form>
          </motion.div>
      </div>
      <p></p>
    </div>
  )
}

export default ExpertForm